// extracted by mini-css-extract-plugin
export default {"searchContainer":"LocationsTable_searchContainer__s4N3v"};